import { JWMCarousel } from "@components/JWMCarousel/JWMCarousel";
import { CMSBlock } from "@jwm/types/CMSBlock";
import React from "react";

interface CarouselBlockProps {
    component: CMSBlock["carousel"];
    placement: string;
    sectionIndex?: number;
    siteSpecialty?: {
        type: string;
        title: string;
    };
}

export const CarouselBlock = ({
    component,
    placement,
    sectionIndex = 0,
    siteSpecialty,
}: CarouselBlockProps): JSX.Element => (
    <JWMCarousel
        carouselContent={component}
        placement={placement}
        titleComponent={"span"}
        loading={sectionIndex === 0 ? "eager" : "lazy"}
        siteSpecialty={siteSpecialty}
    />
);
